export default __webpack_public_path__ + "static/media/chocolate.63e5fb64.webp";